// Mock Data for Jay Defence Academy

export const bootcampPrograms = [
  {
    id: 1,
    name: "SSB Bootcamp",
    tagline: "14-Day Intensive Training",
    description: "Crack the SSB with Confidence! Learn from top assessors and experts, maximizing your chances of clearing the SSB in your very first try.",
    highlights: ["One-on-one sessions with Psychologist, IO & GTO", "Personality improvement as per OLQs", "Physical fitness training"],
    registration: 1000,
    color: "gold"
  },
  {
    id: 2,
    name: "90 Days CDS Program",
    tagline: "Complete CDS Exam Preparation",
    description: "Comprehensive training for Combined Defence Services examination. Master all subjects with expert guidance from decorated veterans.",
    highlights: ["Complete syllabus coverage", "Daily practice tests", "Personality development sessions"],
    registration: 1000,
    color: "olive"
  },
  {
    id: 3,
    name: "90 Days NDA Program",
    tagline: "National Defence Academy Prep",
    description: "Transform into a future officer with our intensive NDA preparation program. Join the elite forces of Indian Army, Navy or Air Force.",
    highlights: ["Mathematics & GAT training", "Personality improvement as per OLQs", "Physical training module"],
    registration: 1000,
    color: "navy"
  }
];

export const featuredInstructor = {
  id: 0,
  name: "Flt Lt Deeksha Shukla (Retd)",
  role: "Personality Development Coach",
  isNew: true,
  image: "https://customer-assets.emergentagent.com/job_3aab63d3-c9e2-482d-bd9e-777479c50305/artifacts/i3gts73o_Deeksha-Photograph.jpg",
  shortBio: "Former Indian Air Force pilot with over a decade of operational experience. DG NCC Commendation holder who graduated First in Overall Order of Merit at the Air Force Academy. Now joining Jay Defence Academy to help aspirants develop Officer-Like Qualities.",
  achievements: [
    "DG NCC Commendation holder",
    "Graduated First in Overall Order of Merit at Air Force Academy",
    "Represented India at Republic Day 2006 parade",
    "Delivered 500+ training sessions across India & internationally"
  ],
  expertise: [
    "Personality Development",
    "SSB Preparation & OLQ Development",
    "Mental Agility & Emotional Resilience",
    "Leadership & Decision Making"
  ],
  experience: "Over a decade as an Indian Air Force pilot, commanding aircraft through complex high-stakes missions including casualty evacuations, para-drop operations, and ceremonial fly-pasts. Co-Founder of SOULSARA (HealthTech platform). Trusted to deliver high-impact programs for IAS/IPS officers under Mission Karmayogi.",
  organizations: ["Indian Air Force", "Indian Army", "JSW", "Vodafone", "Anand Group", "Government of India"]
};

export const instructors = [
  {
    id: 1,
    name: "Col JD Sahastrabudhe (Retd)",
    role: "Founder",
    description: "Brings over 30 years of operational experience, including CI/CT operations and UN missions.",
    image: null
  },
  {
    id: 2,
    name: "Brig Vidur Narvekar (Retd)",
    role: "Personality Development Expert",
    description: "Specializes in personality development and leadership training.",
    image: null
  },
  {
    id: 3,
    name: "Col SV Patwardhan (Retd)",
    role: "GTO Training Expert",
    description: "Excels in GTO (Group Testing Officer) training with decades of experience.",
    image: null
  },
  {
    id: 4,
    name: "Col SB Deshpande (Retd)",
    role: "Senior Mentor",
    description: "Offers 24+ years of mentoring expertise in defence preparation.",
    image: null
  },
  {
    id: 5,
    name: "Col Ganesh Bhat (SM)",
    role: "Seasoned Psychologist",
    description: "From 34 SSB SCE Prayagraj. Youngest assessor of his time, recommended over 500 candidates.",
    image: null
  },
  {
    id: 6,
    name: "Col Shivanand Sutagatti",
    role: "Veteran GTO & Kargil War Hero",
    description: "Alumnus of Sainik School Bijapur and NDA. Veteran of Kargil War (Operation Vijay) and J&K ops. Former GTO at SSB Prayagraj (assessed 6,000+ candidates).",
    image: null
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Both the sessions were very helpful. It was great to learn about how the responses were to be directed... Helped me get through phase 1.",
    author: "Defence Aspirant",
    rating: 5
  },
  {
    id: 2,
    text: "I would like to thank the team for providing valuable guidance during my SSB preparation for NCC Special Entry... The sessions conducted by Psychologist Deshpande Sir were insightful.",
    author: "Anudeep R",
    rating: 5
  },
  {
    id: 3,
    text: "Situated in the Yeri classes building the academy is the best in the business with quality teachers and ex armed forces officers...",
    author: "SSB Candidate",
    rating: 5
  }
];

export const courses = [
  {
    id: 1,
    name: "SSB Course",
    price: 15000,
    duration: "14 Days",
    features: [
      "One on one sessions with Psychologist, IO, and GTO",
      "Personality improvement as per OLQs",
      "Physical fitness plan to follow till SSB",
      "Detailed analysis on shortcomings and strengths"
    ],
    popular: true
  },
  {
    id: 2,
    name: "90 Day Defence Program",
    price: 20000,
    duration: "90 Days",
    features: [
      "Training in all subjects of CDS / NDA / AFCAT exams",
      "Free Optional physical training plan",
      "Paper solving for exam prep",
      "Personality development virtual sessions"
    ],
    popular: false
  }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Our Courses", path: "/courses" },
  { name: "NDA Mock Exams", path: "/mock-exams" },
  { name: "OLQ Tracker", path: "/olq-tracker" },
  { name: "Notifications", path: "/notifications" },
  { name: "About Dharwad", path: "/about-dharwad" },
  { name: "Contact", path: "/contact" }
];

export const footerLinks = [
  { name: "Terms and Conditions", path: "/terms" },
  { name: "Contact", path: "/contact" },
  { name: "Cancellation & Refund Policy", path: "/refund-policy" }
];

export const socialLinks = [
  { name: "Instagram", url: "https://www.instagram.com/jaydefenceacademy/", icon: "instagram" },
  { name: "LinkedIn", url: "https://www.linkedin.com/in/jitendra-sahastrabudhe-7454231a/", icon: "linkedin" }
];

export const contactInfo = {
  email: "info@jaydefenceacademy.com",
  phone: "+91 7204064650",
  address: "2nd Floor, Yeri Classes, Vidyagiri, Dharwad, Karnataka, India"
};

export const logoUrl = "https://customer-assets.emergentagent.com/job_fc258e20-8d5c-4b8d-a77a-14fec33cbe9c/artifacts/1wawnoyr_logo_jdef3.png";

export const defenceNotifications = [
  {
    id: 1,
    title: "NDA & NA (I) 2026",
    examName: "National Defence Academy & Naval Academy Examination (I) 2026",
    organization: "UPSC",
    notificationDate: "10th December 2025",
    lastDate: "30th December 2025",
    examDate: "13th April 2026",
    eligibility: "Unmarried male & female candidates, 10+2 passed or appearing",
    ageLimit: "16.5 to 19.5 years",
    vacancies: "406 (Army: 208, Navy: 42, Air Force: 120, Naval Academy: 36)",
    applicationFee: "₹100 (Exempted for SC/ST/Female)",
    officialLink: "https://upsc.gov.in",
    pdfUrl: "https://customer-assets.emergentagent.com/job_fc258e20-8d5c-4b8d-a77a-14fec33cbe9c/artifacts/63p65j2l_Notif-NDA-NA-I-2026-Engl-101225-2.pdf",
    status: "closed"
  },
  {
    id: 2,
    title: "CDS (I) 2026",
    examName: "Combined Defence Services Examination (I) 2026",
    organization: "UPSC",
    notificationDate: "10th December 2025",
    lastDate: "30th December 2025",
    examDate: "13th April 2026",
    eligibility: "Graduate for IMA/INA/AFA, Degree holders for OTA",
    ageLimit: "19 to 25 years (varies by academy)",
    vacancies: "457 (IMA: 100, INA: 32, AFA: 32, OTA Men: 275, OTA Women: 18)",
    applicationFee: "₹200 (Exempted for SC/ST/Female)",
    officialLink: "https://upsc.gov.in",
    pdfUrl: "https://customer-assets.emergentagent.com/job_fc258e20-8d5c-4b8d-a77a-14fec33cbe9c/artifacts/5x6ilxjm_Notif-CDSE-I-2026-Engl-101225-3.pdf",
    status: "closed"
  },
  {
    id: 3,
    title: "AFCAT 01/2026",
    examName: "Air Force Common Admission Test 01/2026",
    organization: "Indian Air Force",
    notificationDate: "December 2025",
    lastDate: "10th January 2026",
    examDate: "21st-23rd February 2026",
    eligibility: "Graduate with 60% marks (Physics & Maths at 10+2 for Flying/Tech branches)",
    ageLimit: "20 to 24 years (Flying), 20 to 26 years (Ground Duty)",
    vacancies: "As per notification",
    applicationFee: "₹250",
    officialLink: "https://afcat.cdac.in",
    pdfUrl: "https://customer-assets.emergentagent.com/job_fc258e20-8d5c-4b8d-a77a-14fec33cbe9c/artifacts/a82chu4n_Notification_AFCAT_01-2026-4.pdf",
    status: "closed"
  },
  {
    id: 4,
    title: "SSC Tech-67 (Men)",
    examName: "67th Short Service Commission (Technical) Men - October 2026",
    organization: "Indian Army",
    notificationDate: "January 2026",
    lastDate: "5th February 2026",
    examDate: "SSB: April-June 2026",
    eligibility: "Engineering Degree (B.E./B.Tech) in notified streams, Unmarried Male",
    ageLimit: "20 to 27 years as on 01 Oct 2026",
    vacancies: "As per notification",
    applicationFee: "Nil",
    officialLink: "https://joinindianarmy.nic.in",
    pdfUrl: "https://customer-assets.emergentagent.com/job_training-center-12/artifacts/ojj4y24b_COMBINE_NOTFN.pdf",
    status: "active",
    highlights: [
      "Training: 49 weeks at OTA Chennai",
      "Stipend: ₹56,100/month during training",
      "CTC: ~₹17-18 Lac/annum after commissioning",
      "Permanent Commission option after 10 years"
    ]
  },
  {
    id: 5,
    title: "SSC Tech-67 (Women)",
    examName: "67th Short Service Commission (Technical) Women - October 2026",
    organization: "Indian Army",
    notificationDate: "January 2026",
    lastDate: "4th February 2026",
    examDate: "SSB: April-June 2026",
    eligibility: "Engineering Degree (B.E./B.Tech) in notified streams, Unmarried Female",
    ageLimit: "20 to 27 years as on 01 Oct 2026",
    vacancies: "As per notification",
    applicationFee: "Nil",
    officialLink: "https://joinindianarmy.nic.in",
    pdfUrl: "https://customer-assets.emergentagent.com/job_training-center-12/artifacts/az4zgiej_COMBINE_NOTIFICATION.pdf",
    status: "active",
    highlights: [
      "Training: 49 weeks at OTA Gaya, Bihar",
      "Stipend: ₹56,100/month during training",
      "Permanent Commission option after 10 years",
      "Special provisions for Defence widows"
    ]
  },
  {
    id: 6,
    title: "Indian Navy SSC - Jan 2027",
    examName: "Short Service Commission Officers - Jan 2027 (ST 27) Course",
    organization: "Indian Navy",
    notificationDate: "January 2026",
    lastDate: "24th February 2026",
    examDate: "SSB Interview (dates to be notified)",
    eligibility: "BE/B.Tech with 60% marks in any discipline, Unmarried Men & Women",
    ageLimit: "Born between 02 Jan 2002 to 01 Jan 2006",
    vacancies: "Multiple entries (Executive, Engineering, Electrical, Education branches)",
    applicationFee: "Nil",
    officialLink: "https://www.joinindiannavy.gov.in",
    pdfUrl: "https://customer-assets.emergentagent.com/job_training-center-12/artifacts/55g094c0_Advertisement_SSC_Jan_2027.pdf",
    status: "active",
    highlights: [
      "Training at INA Ezhimala, Kerala",
      "Starting salary: ~₹1,25,000/month",
      "12-year commission (extendable by 2 years)",
      "Multiple branches: Executive, Engineering, Electrical, Education",
      "5% relaxation for NCC 'C' certificate holders"
    ]
  }
];
